export default "__VITE_ASSET__DNPbmnE5__"